import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-for',
  templateUrl: './step-for.component.html',
  styleUrls: ['./step-for.component.scss']
})
export class StepForComponent implements OnInit {

  pageTitle: string;

  routeId = JSON.parse(localStorage.getItem('currentRouteId'));
  currentRoute: any;
  currentRoutePoints = JSON.parse(localStorage.getItem('currentRoutePoints'));

  constructor() { }

  ngOnInit(): void {
    this.currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);
    this.pageTitle = 'Édition du circuit ' + this.currentRoute.title;
  }

}
